import * as React from 'react'

export const Certificate = () => (
  <svg
    width="74"
    height="78"
    viewBox="0 0 74 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_431_786)" filter="url(#filter0_d_431_786)">
      <path
        d="M57.5038 70.0001H6.50684V4.79102H57.5038V70.0001Z"
        fill="#FFA0BF"
      />
      <path
        d="M63.493 65.2091L46.5404 59.9966L21.5437 57.8162C16.3118 56.8941 12.4961 52.3376 12.4961 47.0116V0H63.493V65.2091Z"
        fill="#FFEEF4"
      />
      <path d="M56.4507 0V63.968L63.4929 65.2091V0L56.4507 0Z" fill="#FFD4E2" />
      <path
        d="M21.812 57.8264L63.4929 65.2093L31.087 45.4629C31.087 45.4629 31.5189 57.8264 21.812 57.8264Z"
        fill="#E15986"
      />
      <path
        d="M21.8725 11.7571H54.1169C54.7003 11.7571 55.1732 11.2842 55.1732 10.7008C55.1732 10.1174 54.7003 9.64453 54.1169 9.64453H21.8725C21.2891 9.64453 20.8162 10.1174 20.8162 10.7008C20.8162 11.2842 21.2891 11.7571 21.8725 11.7571Z"
        fill="#FFA5C3"
      />
      <path
        d="M54.1169 16.1582H21.8725C21.2891 16.1582 20.8162 16.6311 20.8162 17.2145C20.8162 17.7979 21.2891 18.2708 21.8725 18.2708H54.1169C54.7003 18.2708 55.1732 17.7979 55.1732 17.2145C55.1732 16.6311 54.7004 16.1582 54.1169 16.1582Z"
        fill="#FFA5C3"
      />
      <path
        d="M54.1169 22.6699H21.8725C21.2891 22.6699 20.8162 23.1428 20.8162 23.7262C20.8162 24.3096 21.2891 24.7825 21.8725 24.7825H54.1169C54.7003 24.7825 55.1732 24.3096 55.1732 23.7262C55.1732 23.1428 54.7004 22.6699 54.1169 22.6699Z"
        fill="#FFA5C3"
      />
      <path
        d="M51.0467 29H21.9528C21.4265 29 20.9998 29.4477 20.9998 30C20.9998 30.5523 21.4265 31 21.9528 31H51.0467C51.5731 31 51.9998 30.5523 51.9998 30C51.9998 29.4477 51.5732 29 51.0467 29Z"
        fill="#FFA5C3"
      />
      <path
        d="M47.6491 33.8087L52.9656 21.0251L48.6962 19.2637L42.5708 33.9922C42.3127 34.6127 42.8966 35.2522 43.5412 35.0552L47.0145 33.9936C47.1176 33.9621 47.2167 33.9525 47.3188 33.9624L47.6491 33.8087Z"
        fill="white"
      />
      <path
        d="M52.74 20.9316L47.3206 33.9628C47.5829 33.9861 47.8249 34.1377 47.9545 34.3811L49.6567 37.578C49.9727 38.1713 50.8395 38.1303 51.0977 37.5098L57.2231 22.7812L52.74 20.9316Z"
        fill="#FFE4ED"
      />
      <path
        d="M57.3821 20.8828L52.7798 22.7816L58.9052 37.5102C59.1632 38.1307 60.0301 38.1717 60.3461 37.5783L62.0484 34.3814C62.1008 34.283 62.1716 34.1994 62.2547 34.1333L62.6715 33.6087L57.3821 20.8828Z"
        fill="white"
      />
      <path
        d="M67.428 33.9922L61.3025 19.2637L56.8352 21.1067L62.2527 34.133C62.4535 33.9732 62.7257 33.9146 62.9842 33.9936L66.4575 35.0552C67.1022 35.2523 67.6861 34.6128 67.428 33.9922Z"
        fill="#FFE4ED"
      />
      <path
        d="M56.5382 0.53393C57.1788 1.04018 58.0292 1.19848 58.8102 0.956977C59.9084 0.617277 61.0968 1.07587 61.6786 2.0638C62.0924 2.76636 62.8279 3.21998 63.6438 3.27572C64.791 3.35409 65.7328 4.20932 65.9171 5.33989C66.0481 6.1439 66.5695 6.83146 67.3101 7.17703C68.3514 7.66294 68.9195 8.79923 68.6812 9.91971C68.5118 10.7165 68.7485 11.5453 69.3137 12.1339C70.1085 12.9617 70.2261 14.2257 69.5976 15.1848C69.1505 15.8669 69.0707 16.7248 69.3843 17.4771C69.8252 18.5349 69.4764 19.7558 68.5425 20.424C67.8783 20.8992 67.4927 21.6705 67.5122 22.4848C67.5397 23.6298 66.7717 24.6428 65.6584 24.9299C64.8667 25.134 64.2274 25.7145 63.9503 26.4808C63.5606 27.5584 62.477 28.2267 61.3348 28.0937C60.5226 27.9992 59.7159 28.3104 59.1795 28.9253C58.4253 29.79 57.1725 30.0232 56.1557 29.4884C55.4326 29.108 54.5674 29.108 53.8443 29.4884C52.8275 30.0233 51.5747 29.79 50.8205 28.9253C50.2841 28.3104 49.4775 27.9992 48.6652 28.0937C47.523 28.2267 46.4395 27.5584 46.0497 26.4808C45.7726 25.7145 45.1333 25.134 44.3416 24.9299C43.2283 24.6429 42.4603 23.6298 42.4878 22.4848C42.5073 21.6705 42.1217 20.8992 41.4575 20.424C40.5235 19.7558 40.1748 18.5349 40.6157 17.4771C40.9293 16.7248 40.8495 15.8669 40.4024 15.1848C39.7739 14.2257 39.8915 12.9617 40.6863 12.1339C41.2515 11.5453 41.4882 10.7165 41.3188 9.91971C41.0806 8.79923 41.6486 7.66286 42.69 7.17703C43.4306 6.83146 43.9519 6.1439 44.0829 5.33989C44.2672 4.20932 45.209 3.35417 46.3563 3.27572C47.1722 3.21998 47.9077 2.76636 48.3215 2.0638C48.9033 1.07587 50.0917 0.617352 51.1899 0.956977C51.9709 1.19856 52.8213 1.04018 53.4619 0.53393C54.3628 -0.177977 55.6373 -0.177977 56.5382 0.53393Z"
        fill="#E15986"
      />
      <path
        d="M61.7526 14.8868C61.7526 9.86186 58.4979 5.59428 53.9737 4.06055C48.4259 4.57622 44.0835 9.2264 44.0835 14.8868C44.0835 20.5473 48.4259 25.1975 53.9737 25.7131C58.498 24.1794 61.7526 19.9119 61.7526 14.8868Z"
        fill="#FFDAE7"
      />
      <path
        d="M55.002 4.01367C54.1663 4.01367 53.3525 4.10756 52.5706 4.28472C57.4296 5.38553 61.0565 9.71449 61.0565 14.8875C61.0565 20.0604 57.4296 24.3894 52.5706 25.4902C53.3525 25.6674 54.1663 25.7612 55.002 25.7612C61.0315 25.7612 65.9195 20.8929 65.9195 14.8875C65.9195 8.88205 61.0315 4.01367 55.002 4.01367Z"
        fill="#FFA5C3"
      />
      <path
        d="M55.3002 19.0609L59.0683 21.5872C59.2164 21.6865 59.3802 21.7011 59.5235 21.6572C59.6566 21.4769 59.7846 21.2926 59.9073 21.1045C59.9044 21.0687 59.8977 21.032 59.8871 20.9947L58.6392 16.6448C58.579 16.4348 58.6525 16.2095 58.8252 16.0749L61.7028 13.8312C61.6551 13.3117 61.5724 12.8022 61.4572 12.3051L57.5498 12.1655C57.3307 12.1577 57.1383 12.0184 57.0631 11.8133L55.5054 7.56346C55.3332 7.09343 54.6657 7.09343 54.4934 7.56346L52.9358 11.8131C52.8606 12.0182 52.6682 12.1575 52.4491 12.1653L47.9099 12.3275C47.4078 12.3454 47.2016 12.9776 47.5971 13.2861L51.1738 16.0748C51.3464 16.2093 51.4199 16.4347 51.3597 16.6446L50.1119 20.9946C49.9739 21.4758 50.5138 21.8664 50.9306 21.5871L54.6987 19.0608C54.8805 18.939 55.1184 18.939 55.3002 19.0609Z"
        fill="#E15986"
      />
      <path
        d="M59.07 21.5863C59.4868 21.8657 60.0268 21.475 59.8887 20.9938L59.6625 20.2051C59.4197 20.6355 59.148 21.0475 58.8506 21.4392L59.07 21.5863Z"
        fill="#CB4672"
      />
      <path
        d="M62.0924 12.3276L60.741 12.2793C60.9059 12.9467 61.0088 13.6382 61.0437 14.3478L62.4051 13.2862C62.8007 12.9778 62.5944 12.3456 62.0924 12.3276Z"
        fill="#CB4672"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_431_786"
        x="-4"
        y="0"
        width="78"
        height="78"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_431_786"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_431_786"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_431_786">
        <rect width="70" height="70" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
